/* German locals for flatpickr */
var flatpickr = flatpickr || { l10ns: {} };
flatpickr.l10ns.de = {};

flatpickr.l10ns.de.weekdays = {
	shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
	longhand: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
};

flatpickr.l10ns.de.months = {
	shorthand: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
	longhand: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
};

flatpickr.l10ns.de.firstDayOfWeek = 1;
flatpickr.l10ns.de.weekAbbreviation = "KW";
flatpickr.l10ns.de.rangeSeparator = " bis ";
flatpickr.l10ns.de.scrollTitle = "Zum Ändern scrollen";
flatpickr.l10ns.de.toggleTitle = "Zum Umschalten klicken";

if (typeof module !== "undefined") module.exports = flatpickr.l10ns;


//////////////////
// WEBPACK FOOTER
// ./~/flatpickr/dist/l10n/de.js
// module id = 14
// module chunks = 0 1